import styled, { keyframes } from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const LogosSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  padding: 36px 0;
`;

export const CarouselWrapper = styled.aside`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 64px;
  overflow: hidden;

  &::before,
  &::after {
    content: '';
    display: block;
    height: 100%;
    width: 120px;
    position: absolute;
    top: 0;
    z-index: 2;

    ${screen.md} {
      width: 220px;
    }
  }

  &::before {
    left: 0;
    background: linear-gradient(to left, rgba(7, 19, 24, 0), ${homeColor.bg});
  }
  &::after {
    right: 0;
    background: linear-gradient(to right, rgba(7, 19, 24, 0), ${homeColor.bg});
  }

  ${screen.md} {
    height: 80px;
  }
`;

const logosScroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
`;

export const Label = styled.p`
  font-family: ${getToken('font-family-default')};
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${homeColor.white};
  text-align: center;
  margin: 0;
  padding: 0 20px;
`;

export const LogosSlider = styled.div`
  width: 100%;
  overflow: hidden;
  display: inline-flex;
`;

export const LogosList = styled.div`
  display: inline-flex;
  justify-content: space-between;

  animation: ${(props) => props.items}s ${logosScroll} infinite linear;

  @media (prefers-reduced-motion: reduce) {
    animation-play-state: paused;
  }
`;

export const Logo = styled.div`
  box-sizing: border-box;
  position: relative;
  height: 36px;
  width: 110px;
  margin: 0 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: none;

  ${screen.md} {
    margin: 0 32px;
    height: 46px;
    width: 160px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
